import { Avatar, AvatarGroup, Box, Tooltip, Typography } from '@mui/material';
import AvatarImage from './avatar-image';
import { IAvatarGroup } from './utils/interfaces';

interface IAvatarGroupProps {
  members: IAvatarGroup[];
  max: number;
  size: number;
  fontSize: string;
}
const CustomAvatarGroup = ({
  members,
  max,
  size,
  fontSize
}: IAvatarGroupProps): JSX.Element => {
  const excessMembers = members.slice(max);
  return (
    <Box
      sx={{
        display: 'flex'
      }}
    >
      <AvatarGroup
        data-testid={'avatar-group'}
        max={max}
        sx={{
          '& .MuiAvatar-root': {
            border: '2px solid white',
            width: size,
            height: size
          }
        }}
      >
        {members.slice(0, max).map((member, index) => (
          <Box
            key={member.id}
            sx={{
              alignItems: 'flex-start',
              flexDirection: 'row',
              zIndex: index + 1,
              marginLeft: '-10px'
            }}
          >
            <Tooltip
              title={member.displayName}
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    background: '#f2f3fb',
                    color: '#37383C',
                    fontSize: '10px',
                    fontWeight: 400,
                    lineHeight: '12.1px'
                  }
                },
                arrow: {
                  sx: {
                    color: '#f2f3fb'
                  }
                }
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '12px',
                  alignItems: 'center'
                }}
              >
                <AvatarImage
                  providerId={member.providerId}
                  width="50px"
                  height="50px"
                  key={member.id}
                  fontSize={fontSize}
                  alt={member.displayName}
                />
              </Box>
            </Tooltip>
          </Box>
        ))}
      </AvatarGroup>
      {excessMembers.length > 0 && (
        <Box
          sx={{
            '& .MuiAvatar-root': {
              border: '2px solid white',
              width: size + 4,
              height: size + 4
            },
            zIndex: max,
            marginLeft: '-10px'
          }}
        >
          <Tooltip
            title={
              <Box sx={{ textAlign: 'center' }}>
                {excessMembers.map((member) => (
                  <Box key={member.id}>{member.displayName}</Box>
                ))}
              </Box>
            }
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  background: '#f2f3fb',
                  color: '#37383C',
                  fontSize: '10px',
                  fontWeight: 400
                }
              },
              arrow: {
                sx: {
                  color: '#f2f3fb'
                }
              }
            }}
          >
            <Avatar>
              <Typography
                sx={{
                  fontSize: { fontSize }
                }}
              >
                +{excessMembers.length}
              </Typography>
            </Avatar>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default CustomAvatarGroup;
